<template>
    <div id="left-container" class="go-button-container" v-show="!store.onlyRead">
        <div id="right-button" class="go-button" @click="goPage('go_right_page')"></div>
        <div id="left-button" class="go-button" @click="goPage('go_left_page')"></div>
    </div>
    <div id="right-container" class="go-button-container" v-show="!store.onlyRead">
        <div id="right-button" class="go-button" @click="goPage('go_right_page')"></div>
        <div id="left-button" class="go-button" @click="goPage('go_left_page')"></div>
    </div>
</template>

<script>
import EventBus from '../js/event_bus';
import { store } from '../store';

export default {
    name: "ChangePageButtons",
    data: function () {
        return {
            show: true,
            store
        }
    },
    methods: {
        goPage(type) {
            EventBus.getInstance().emit(type);
        }
    }
};
</script>

<style src="../assets/css/ChangePageButtons.css" scoped>

</style>
